import { RouterProvider } from "react-router-dom";
import { getRouterConfiguration } from './service/router'

function App() {
  return (
    <div>
      <RouterProvider router={getRouterConfiguration()} />
    </div>
  );
}

export default App;
